import {mapState} from 'vuex';
export default {
  data() {
    return {
      // 表格高度
      tableHeight: 0,
      // 详情内容的高度
      detailHeight: 0
    };
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },

  methods: {
    formatIndex(prefix, index, digits = 4) {
      return `${prefix}${(index + 1).toString().padStart(digits, '0')}`;
    },
    // 设置表格高度
    setTableHeight() {
      const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
      const mainheaderHeight = document.querySelector('.main-header')?.offsetHeight || 0;
      const changeTabHeight = document.querySelector('.change-tab')?.offsetHeight || 0;
      const searchHeight = document.querySelector('.search')?.offsetHeight || 0;
      const paginationHeight = document.querySelector('.pagination-container')?.offsetHeight || 0;
      const allHeight = headerHeight + mainheaderHeight + searchHeight + paginationHeight + changeTabHeight + 64;
      this.tableHeight = Math.max(0, window.innerHeight - allHeight);
      this.detailHeight = this.tableHeight + 32;
    }
  },
  created() {
    this.$nextTick(() => {
      this.setTableHeight();
    });
    window.addEventListener('resize', this.setTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight);
  }
};
